/*
 * @Author: zhangbs skytot@163.com
 * @Date: 2022-06-15 17:18:56
 * @LastEditors: zhangbs skytot@163.com
 * @LastEditTime: 2022-06-21 16:03:46
 * @FilePath: \vite-projectd:\AIJS\acro-webpack\src\utils\route.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

/**
 * @description:
 * @param {any} item
 * @return {*}
 */
function setMeta(item: any) {
  return {
    locale: item.meta.title,
    requiresAuth: true,
    icon: item.meta.icon && item.meta.icon != "#" ? item.meta.icon : "",
    hideInMenu: item.hidden || false,
  };
}

function transData(data: any) {
  for (let i in data) {
    data[i].meta = setMeta(data[i]);
    data[i].name = data[i].name[0].toLowerCase() + data[i].name.substring(1);
    if (data[i].children && data[i].children.length > 0) {
      transData(data[i].children);
    }
  }
}
const computedRouter = (data: any) => {
  let defaultData = [];
  if (Array.isArray(data)) {
    defaultData = JSON.parse(JSON.stringify(data));
    transData(defaultData);
  }
  return defaultData;
};
export default computedRouter;
